import { IconButton, styled } from "@mui/material";

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  "&:hover": {
    backgroundColor: `${theme.palette.primary.dark}`,
    color: `${theme.palette.primary.contrastText}`,
  },
}));
